// extracted by mini-css-extract-plugin
export default {"rootdiv":"RootDiv_rootdiv__QPZSH"};